import React from 'react';

class Number extends React.Component {
  handleChange = e => {
    e.preventDefault();
    this.props.onChange({
      target: {
        name: this.props.name,
        value: parseInt(e.target.value)
      }
    });
  };

  render() {
    const { value, isAutofocus, forwardRef } = this.props;

    return (
      <input
        {...this.props}
        ref={forwardRef}
        type="number"
        value={typeof value === 'undefined' ? '' : value}
        onChange={this.handleChange}
        autoFocus={isAutofocus || false}
      />
    );
  }
}

export default Number;
